module.exports = __webpack_public_path__ + "img/qy (44).60a0f9c0.jpg";